export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScrpt to be fired on the home page, after the init JS
      $( document ).ready(function() {                      //run when the DOM is ready
        /*  $('#home-faq .card-header').click(function() {  //use a class, since your ID gets mangled
              $(this).find('.card-faq').toggleClass('show');
          }); */
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js